import { DuplicateIcon } from '@approvalmax/ui';
import { Flex, List } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import { getPath, Path } from 'urlBuilder';

import { messages } from './DuplicateList.messages';
import { IconContainer, Root } from './DuplicateList.styles';
import { DuplicateListProps } from './DuplicateList.types';

export const DuplicateList: FC<DuplicateListProps> = memo((props) => {
    const { possibleDuplicates, companyId } = props;

    return (
        <Root>
            <Flex container wrap={false} alignItems='center'>
                <IconContainer>
                    <DuplicateIcon />
                </IconContainer>

                <div>
                    {messages.description}

                    <List spacing='4 0'>
                        {possibleDuplicates.map((item) => (
                            <List.Item key={item.requestId}>
                                <Link
                                    to={getPath(Path.request, item.requestId, companyId)}
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {item.friendlyName}
                                </Link>
                            </List.Item>
                        ))}
                    </List>
                </div>
            </Flex>
        </Root>
    );
});

DuplicateList.displayName = 'DuplicateList';
